<template>
    <div>
        <div class="row">
        <div class="alert alert-success text-center col-sm-6" role="alert">
  <h6>Today:Ksh.{{ formatPrice(profit_today) }}</h6>

</div>
<div class="alert alert-primary text-center col-sm-6" role="alert">
  <h6>Total:Ksh.{{ formatPrice(profit_total) }}</h6>

</div>

      </div>
     <div class="row">
                      <div class="col-xl-3 col-lg-6 col-sm-6 grid-margin stretch-card">
                        <div class="card">
                          <div class="card-body text-center">
                            <!-- <h5 class="mb-2 text-dark font-weight-normal">Users</h5> -->
                            <h4 class="mb-4 text-dark font-weight-bold">Airtime <i>Sold</i> today</h4>
                            <div class="dashboard-progress dashboard-progress-1 d-flex align-items-center justify-content-center item-parent"><img src="/images/saf.jpeg" style="width: 20%;" class=" absolute-center text-info"></div>
                            <!-- <p class="mt-4 mb-5">Completed</p> -->
                            <h4 class="mb-0 mt-5 font-weight-bold mt-2 text-dark">Ksh. {{formatPrice(report.sent_today)}}</h4>
                          </div>
                        </div>
                      </div>
                      <div class="col-xl-3 col-lg-6 col-sm-6 grid-margin stretch-card">
                        <div class="card">
                          <div class="card-body text-center">
                            <!-- <h5 class="mb-2 text-dark font-weight-normal">Users</h5> -->
                            <h4 class="mb-4 text-dark font-weight-bold">Airtime Converted Today</h4>
                            <div class="dashboard-progress dashboard-progress-1 d-flex align-items-center justify-content-center item-parent"><img src="/images/mpesa.png" style="width: 20%;" class=" absolute-center text-info"></div>
                            <!-- <p class="mt-4 mb-5">Completed</p> -->
                            <h4 class="mb-0 mt-5 font-weight-bold mt-2 text-dark">Received today: {{formatPrice(report.received_today)}}</h4>
                          </div>
                        </div>
                      </div>
                      <div class="col-xl-3 col-lg-6 col-sm-6 grid-margin stretch-card">
                        <div class="card">
                          <div class="card-body text-center">
                            <!-- <h5 class="mb-2 text-dark font-weight-normal">Users</h5> -->
                            <h4 class="mb-4 text-dark font-weight-bold">Safaricom Artime Sold</h4>
                            <div class="dashboard-progress dashboard-progress-1 d-flex align-items-center justify-content-center item-parent"><img src="/images/saf.jpeg" style="width: 20%;" class=" absolute-center text-info"></div>
                            <!-- <p class="mt-4 mb-5">Completed</p> -->
                            <h3 class="mb-0 mt-5 font-weight-bold mt-2 text-dark">Ksh.{{formatPrice(report.saf)}}</h3>
                          </div>
                        </div>
                      </div>
                      <div class="col-xl-3 col-lg-6 col-sm-6 grid-margin stretch-card">
                        <div class="card">
                          <div class="card-body text-center">
                            <!-- <h5 class="mb-2 text-dark font-weight-normal">Users</h5> -->
                            <h4 class="mb-4 text-dark font-weight-bold">Other Airtime Sold</h4>
                            <div class="dashboard-progress dashboard-progress-1 d-flex align-items-center justify-content-center item-parent"><img src="/images/airtel2.png" style="width: 20%;" class=" absolute-center text-info"></div>
                            <!-- <p class="mt-4 mb-5">Completed</p> -->
                            <h3 class="mb-0 mt-5 font-weight-bold mt-2 text-dark">Ksh.{{formatPrice(report.other)}}</h3>
                          </div>
                        </div>
                      </div>
                      <div class="col-xl-3 col-lg-6 col-sm-6 grid-margin stretch-card">
                        <div class="card">
                          <div class="card-body text-center">
                            <!-- <h5 class="mb-2 text-dark font-weight-normal">Users</h5> -->
                            <h4 class="mb-4 text-dark font-weight-bold">All Artime Converted</h4>
                            <div class="dashboard-progress dashboard-progress-1 d-flex align-items-center justify-content-center item-parent"><img src="/images/mpesa2.png" style="width: 20%;" class=" absolute-center text-info"></div>
                            <!-- <p class="mt-4 mb-5">Completed</p> -->
                            <h3 class="mb-0 mt-5 font-weight-bold mt-2 text-dark">Ksh.{{formatPrice(report.received_total)}}</h3>
                          </div>
                        </div>
                    </div>
                        <div class="col-xl-3 col-lg-6 col-sm-6 grid-margin stretch-card">
                        <div class="card">
                          <div class="card-body text-center">
                            <!-- <h5 class="mb-2 text-dark font-weight-normal">Users</h5> -->
                            <h4 class="mb-4 text-dark font-weight-bold">Customers Converting</h4>
                            <div class="dashboard-progress dashboard-progress-1 d-flex align-items-center justify-content-center item-parent"><img src="/assets/img/google.png" style="width: 10%;" class=" absolute-center text-info"></div>
                            <!-- <p class="mt-4 mb-5">Completed</p> -->
                            <h3 class="mb-0 mt-5 font-weight-bold mt-2 text-dark">{{report.converting}}</h3>
                          </div>
                        </div>
                      </div>
                      <div class="col-xl-3 col-lg-6 col-sm-6 grid-margin stretch-card">
                        <div class="card">
                          <div class="card-body text-center">
                            <!-- <h5 class="mb-2 text-dark font-weight-normal">Users</h5> -->
                            <h4 class="mb-4 text-dark font-weight-bold">Customers Purchasing</h4>
                            <div class="dashboard-progress dashboard-progress-1 d-flex align-items-center justify-content-center item-parent"><img src="/assets/img/login.jpg" style="width: 8%;" class=" absolute-center text-info"></div>
                            <!-- <p class="mt-4 mb-5">Completed</p> -->
                            <h3 class="mb-0 mt-5 font-weight-bold mt-2 text-dark">{{report.purchasing}}</h3>
                          </div>
                        </div>
                      </div>
                      <div class="col-xl-3 col-lg-6 col-sm-6 grid-margin stretch-card">
                        <div class="card">
                          <div class="card-body text-center">
                            <!-- <h5 class="mb-2 text-dark font-weight-normal">Users</h5> -->
                            <h4 class="mb-4 text-dark font-weight-bold">B2C Paybill Balance</h4>
                            <div class="dashboard-progress dashboard-progress-1 d-flex align-items-center justify-content-center item-parent"><img src="/images/mpesa2.png" style="width: 20%;" class=" absolute-center text-info"></div>
                            <!-- <p class="mt-4 mb-5">Completed</p> -->
                            <h3 class="mb-0 mt-5 font-weight-bold mt-2 text-dark">Ksh.{{formatPrice(report.b2cBalance.balance)}}</h3>
                          </div>
                        </div>
                    </div>

                      </div>


                      <div class="row justify-content-center">
                      <div class=" col-sm-6 ">
                         <div class="card">
                          <div class="card-body">
                        <apexchart type=pie width=380 :options="chartOptions" :series="series" />
                          </div>
                         </div>
                      </div>
                      <div class=" col-sm-6">
                         <div class="card">
                          <div class="card-body">
                        <apexchart type=pie width=380 :options="chartOptions3" :series="series3" />
                          </div>
                         </div>
                      </div>

                      </div>
                      <!-- <div class="row justify-content-center mt-5">
                      <div class=" col-sm-12">
                         <div class="card">
                          <div class="card-body">
                        <apexchart type=bar  :options="options" :series="series2" />
                          </div>
                         </div>
                      </div>

                      </div> -->
    </div>
</template>
<script>
    import moment from 'moment'
    export default {
        name: 'App',
        components: {

        },
        data(){
            return {
                discounts:{},
                profit_today:'0',
                profit_total:'0',
              lname:'',
            fname:'',
            report:{},
            series:[],
            series3:[],
             options: {
                    chart: {
                        id: 'vuechart-example'
                    },
                    xaxis: {
                        categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug","Sept","Oct","Nov","Dec"]
                    }
                },
                series2: [{
                    name: 'Monthly data',data:[],
                }],
            chartOptions: {
                    labels: ['Safaricom Airtime', 'Other Airtime'],
                    responsive: [{
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 200
                            },
                            legend: {
                                position: 'bottom'
                            }
                        }
                    }]
                },
                chartOptions3: {
                    labels: ['Artime Received', 'Airtime Sold'],
                    responsive: [{
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 200
                            },
                            legend: {
                                position: 'bottom'
                            }
                        }
                    }]
                },

            }
        },
        created(){
              this.dashboard();
              this.getDiscount();
              setTimeout(() => {
                this.calculate();
                  }, 2000);


        },
        methods: {
            calculate(){
                //Todaty
                var sold_today=(this.report.sent_today)*(100-this.discounts.airtime.rate)/100;
                var bought_today=(this.report.sent_today)*(100-this.discounts.mpesa.rate)/100;
                this.profit_today=sold_today-bought_today;

                //All
                var sold=(this.report.saf)*(100-this.discounts.airtime.rate)/100;
                var bought=(this.report.saf)*(100-this.discounts.mpesa.rate)/100;
                this.profit_total=sold-bought;

            },
            getDiscount(){
                let uri =`/api/auth/discount`;
                this.axios.get(uri, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {

                   this.discounts=response.data;
                }).catch(error => {

                   if (error.response.status === 401) {
                    this.$router.push({name: 'index'});
                    this.$toast.open({message: 'Please sign in!', type: 'error', position: 'top'});

                }else{
                    this.$toast.open({message: 'Something went wrong!.', type: 'error', position: 'top'});
                }

                });
            },

            dashboard(){
                let uri =`/api/auth/dashboard`;
                this.axios.get(uri, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                   this.report=response.data;
                   this.series=[this.report.saf,this.report.other];
                   this.series3=[this.report.received_total,this.report.sold_total];
                    // this.series2[0].data=response.data.series;
                }).catch(error => {
                    if (error.response.status === 401) {
                    this.$router.push({name: 'index'});
                    this.$toast.open({message: 'Please sign in!', type: 'error', position: 'top'});

                }else{
                    this.$toast.open({message: 'Something went wrong!.', type: 'error', position: 'top'});
                }

                });
            },


            formatPrice(value) {
                let val = (value/1).toFixed(2).replace('.', '.');
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            filerDate(date){
                return moment(String(date)).format('MM/DD/YYYY HH:mm')
            }

        },
    }

</script>
